import { render, staticRenderFns } from "./marketTzList.vue?vue&type=template&id=1d4a3ae0&scoped=true"
import script from "./marketTzList.vue?vue&type=script&lang=js"
export * from "./marketTzList.vue?vue&type=script&lang=js"
import style0 from "./marketTzList.vue?vue&type=style&index=0&id=1d4a3ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a3ae0",
  null
  
)

export default component.exports